/**
 * "Add your food handler permit" (core permitNudge; fix/permit-step-read, owner 2026-10-09: "we need a not now option"): one gentle
 * line with one tap, on Today and on Me, until a permit is on file. Never an alarm and never a block: it sits below the day's work.
 */
import { PERMIT_NUDGE, type PermitNudge } from "@logwave/core";
import { LinkButton, Notice } from "./ui.tsx";

export function PermitNudgeLine({ nudge }: { nudge: PermitNudge | null | undefined }) {
  if (!nudge) return null;
  return (
    <div data-testid="permit-nudge">
      <Notice tone="info" icon="camera" title={nudge.remind ? `Reminder: ${nudge.line.charAt(0).toLowerCase()}${nudge.line.slice(1)}` : nudge.line}
        action={<LinkButton small variant="secondary" icon="camera" to="/welcome?permit=1">{PERMIT_NUDGE.action}</LinkButton>}>
        {nudge.detail || undefined}
      </Notice>
    </div>
  );
}
